import { render } from "./ModalQnaProduct.vue?vue&type=template&id=3aa48c5b&scoped=true"
import script from "./ModalQnaProduct.vue?vue&type=script&lang=js"
export * from "./ModalQnaProduct.vue?vue&type=script&lang=js"

import "./ModalQnaProduct.vue?vue&type=style&index=0&id=3aa48c5b&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa48c5b"]])

export default __exports__